const api = {
  endpoint: process.env.PRISMIC_URL,
  access_token: process.env.PRISMIC_API_KEY
}

module.exports = api
